const initialURL = new URLSearchParams(window.location.search);

function productInit() {

    // get product data
    const product = JSON.parse(document.querySelector(".productV3JSON").textContent);
    let activeVariant = JSON.parse(document.querySelector(".variantV3JSON").textContent);

    /*****************
     * GA4
     */

    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: "view_item",
        ecommerce: {
            currency: Shopify.currency.active,
            price: activeVariant.price / 100,
            items: [
                {
                    item_id: product.id,
                    item_name: product.title,
                    item_variant: activeVariant.title,
                    item_category: product.type,
                    price: activeVariant.price / 100,
                    quantity: 1
                }
            ]
        }
    });

    /*****************
     * Product Reviews
     * *************/

    if (window.ratingSnippet && (product.handle === "waterguru-sense" || product.handle === "waterguru-sense-sale" || product.handle === "waterguru-sense-s2-auto-replenishment") || product.handle === "waterguru-sense-s3-pool-monitor") {
        ratingSnippet("productV3Stars", {
            store: "waterguru.com",
            color: "#099BC7",
            linebreak: true,
            usePolaris: true,
            text: "Reviews",
            min_rating: 4,
        });
    }

    document.querySelectorAll('.productV3Stars,.productV3StarsManual').forEach(function (element) {
        element.addEventListener("click", function () {
            window.scroll({
                behavior: "smooth",
                top: document.querySelector("#productReviews").offsetTop
            })
        })
    })

    /*****************
     Companion Product
     ******************/

    // uses the button to swap out content
    if (document.querySelector('.productV3OptionsCompanionButton')) {
        document.querySelector('.productV3OptionsCompanionButton').addEventListener('click', async function () {
            if (!this.dataset.value) return;
            try {
                // get new related product and replace key elements on page
                const sectionId = this.closest('.productV3').id;
                const response = await fetch(`${this.dataset.value}?sections=${sectionId}`)
                if (!response.ok) return;
                const data = await response.json();
                // store data in new div
                const content = data[sectionId]
                const contentDiv = document.createElement('div');
                contentDiv.innerHTML = content;
                // replace the options
                document.querySelector('.productV3').innerHTML = contentDiv.querySelector('.productV3').innerHTML;
                // rerun JS
                productInit();
            } catch (e) {
                console.warn("Unable to complete product update");
                console.error(e);
            }
        })
    }

    /**************
     Product Options
     ***************/

    document.querySelectorAll('.productV3 input').forEach(input => {
        input.addEventListener("change", function () {
            // optional pool types
            if (this.name === 'productV3OptionsUses') {
                // update images
                const label = this.dataset.label;
                if (document.querySelector(`.productV3VisualThumbnailsGroup[data-item="${label}"]`)) {
                    document.querySelectorAll('.productV3VisualThumbnailsGroup').forEach(el => {
                        el.dataset.item === label ? el.classList.add('active') : el.classList.remove('active');
                    })
                }
                // update label next to title
                document.querySelector('.productV3OptionsItemTitleAddition').textContent = this.dataset.tag;
                // if value is not standard, hide skimmer options
                if (this.value === "standard") {
                    document.querySelector('.productV3OptionsItemSkimmers').classList.add('active')
                    // select first option for skimmers which is the standard included skimmer
                    document.querySelector('.productV3OptionsItemSkimmers .productV3OptionsItemLabelInput').checked = true;
                } else {
                    document.querySelector('.productV3OptionsItemSkimmers').classList.remove('active');
                }
            }

            // update display price
            if (activeVariant.compare_at_price > activeVariant.price) {
                document.querySelector('.productV3SummaryPriceCompare').textContent = this.dataset.price
                    ? price(activeVariant.compare_at_price + parseInt(this.dataset.price)) : price(activeVariant.compare_at_price);
            }
            document.querySelector('.productV3SummaryPriceMain').textContent = this.dataset.price
                ? price(activeVariant.price + parseInt(this.dataset.price)) : price(activeVariant.price);

        })
    })

    /****************
     Product Quantity
     *****************/

    let quantity = 1;

    document.querySelectorAll('.productV3SummaryQuantityButton')?.forEach(button => {
        button.addEventListener("click", function () {
            if (this.classList.contains('productV3SummaryQuantityMinus') && quantity > 1) {
                quantity--;
            } else if (this.classList.contains('productV3SummaryQuantityPlus')) {
                quantity++;
            }
            document.querySelector('.productV3SummaryQuantityValue').textContent = String(quantity);
        })
    })

    /**************
     Product ATC
     ***************/

    document.querySelector(".productV3SummaryATC")?.addEventListener("click", async function () {

        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: []
        };

        formData.items.push({
            quantity: quantity,
            id: activeVariant.id,
        })

        // check for subscription
        if (document.querySelector('.productV3SubscriptionLabelInput[value="subscription"]:checked')) {
            formData.items[0].selling_plan = product.selling_plan_groups[0].selling_plans[0].id;
        }

        // look for additional products
        document.querySelectorAll(".productV3OptionsItemLabelInput:checked")?.forEach(el => {
            // no extra items for standards
            if (el.value === 'standard' || el.value === '') return;
            // if skimmer, see if section is active, meaning they are allowed
            if (el.name === 'productV3OptionsSkimmer' && !document.querySelector('.productV3OptionsItemSkimmers').classList.contains('active')) return;
            formData.items.push({
                quantity: 1,
                id: parseInt(el.value),
            })
        })

        // add product
        await addProduct(formData);

        // open cart
        await openCart();

        // GA4
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                subscription_included: document.querySelector("#productV2Subscribe:checked") !== null,
                value: activeVariant.price / 100,
                currency: Shopify.currency.active,
                items: [{
                    item_id: product.id,
                    item_name: product.title,
                    item_variant: activeVariant.title,
                    item_category: product.type,
                    price: activeVariant.price / 100,
                    quantity: 1,
                    subscription_item: document.querySelector("#productV2Subscribe:checked") !== null,
                }]
            }
        });

        // remove loading animation
        this.classList.remove("loading");
    });

    /***********************
     Klaviyo Sense tracking
     **********************/

    // on load check which sense you are on and push data - reruns everytime section is re-rendered
    async function klaviyoMetric(sense3 = true) {
        try {
            sense3
                ? klaviyo.push(["track", "Viewed Sense S3"])
                : klaviyo.push(["track", "Viewed Sense S2"]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }
    }

    if (product.handle === "waterguru-sense-s3-pool-monitor") {
        klaviyoMetric().catch(err => console.log(err));
    } else if (product.handle === "waterguru-sense") {
        klaviyoMetric(false).catch(err => console.log(err));
    }


    /********************
     Product OOS
     *******************/

    document.querySelector("#productV2OOS")?.addEventListener("submit", async function (e) {
        // prevent default
        e.preventDefault();

        // start loading
        document.querySelector("#productV2OOSFormSubmit").classList.add("loading");

        // add to waitlist
        await sendKlaviyoBackInStockRequest(document.querySelector("#productV2OOSFormEmail").value, activeVariant.id)

        // success
        document.querySelector("#productV2OOSTitle").textContent = `Thank You. We will notify you when item is back in stock.`;
        document.querySelector("#productV2OOSSubtitle").remove();
        document.querySelector("#productV2OOSFormEmail").remove();
        document.querySelector("#productV2OOSFormSubmit").remove();
    });


    // check if load in has queries and select that
    if (initialURL.has('spa') && document.querySelector('.productV3OptionsItemLabelInput[data-label="Spa"]')) {
        document.querySelector('.productV3OptionsItemLabelInput[data-label="Spa"]').checked = true;
        document.querySelector('.productV3OptionsItemLabelInput[data-label="Spa"]').dispatchEvent(new Event('change'));
    } else if (initialURL.has('above') && document.querySelector('.productV3OptionsItemLabelInput[data-label="Spa"]')) {
        document.querySelectorAll('.productV3OptionsItemLabelInput').forEach(el => {
            const label = el.dataset.label.toLowerCase();
            if (label.includes('above ground')) {
                el.checked = true;
                el.dispatchEvent(new Event('change'));
            }
        })
    }
}


// run on load
productInit();